// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE


function targetValue($$event) {
  return $$event.target.value;
}

export {
  targetValue ,
  
}
/* No side effect */
